import {
  GanttComponent,
  EditDialogFieldsDirective,
  DayMarkers,
  EditDialogFieldDirective,
  Inject,
  Edit,
  Selection,
  Toolbar,
  ColumnsDirective,
  ColumnDirective,
  CriticalPath,
  ContextMenu,
  Reorder,
  Resize,
  VirtualScroll,
  Filter,
  ColumnMenu,
  PdfExport,
  Sort,
  ExcelExport,
} from '@syncfusion/ej2-react-gantt';
import {
  GetGanttDataByPlan,
  SavePointOfTheGantt,
} from '../../utils/CreateRequest';
import Message from '../../utils/Message/Message';
import { loadingShow } from '../../App';
import { useContext, useEffect, useState } from 'react';
import { ThemeContext } from '../../context/theme.context';
import { GetGanttSettings } from '../../services/CloudScheduler/CloudSchedulerServices';
import { arrayPreparing } from '../../utils/GanttHelper';
import { addToQuery, applyTheRule } from '../../utils/BussinesRuleBuilder';
import { useSelector } from 'react-redux';
import { getParamsDD } from '../../utils/GridParams';
import GlobalDialog from '../../components/GlobalDialog';
import { DateTimePickerComponent } from '@syncfusion/ej2-react-calendars';
import './style.css';
import moment from 'moment';
import axios from 'axios';
import { getFilteredOrder } from '../../utils/Methods/methods';
const editSettings = {
  allowAdding: true,
  allowEditing: true,
  allowDeleting: true,
  allowTaskbarEditing: true,
  showDeleteConfirmDialog: true,
};
const labelSettings = {
  leftLabel: 'TaskName',
  taskLabel: '${Progress}%',
};
const columns = [
  {
    width: '150',
    field: 'pronto_row_id',
    headerText: 'Task ID',
    visible: false,
    allowEditing: false,
  },
  {
    displayAsCheckBox: true,
    type: 'checkbox',
    width: '40',
    field: 'isChecked',
  },
  {
    width: '150',
    field: 'TaskID',
    headerText: 'Task ID',
    isPrimaryKey: true,
    visible: false,
    allowEditing: false,
  },
  {
    field: 'order_code',
    headerText: 'Order#',
    width: 60,
    allowEditing: false,
  },
  {
    field: 'asset_code',
    headerText: 'Asset',
    width: 60,
    allowEditing: false,
  },
  {
    field: 'operationSequence',
    headerText: 'Operation Sequence',
    width: 40,
    allowEditing: false,
  },
  {
    field: 'TaskName',
    headerText: 'Job Name',
    clipMode: 'EllipsisWithTooltip',
    width: 240,
  },
  {
    field: 'tradeCode',
    headerText: 'Trade',
    width: 60,
    allowEditing: true,
    edit: getParamsDD(
      { text: 'trade_code', value: 'trade_id' },
      'tradeCode',
      'trade'
    ),
  },
  {
    field: 'required',
    headerText: 'Reqd',
    width: 60,
    allowEditing: true,
    type: 'numeric',
    format: 'c2',
    editType: 'numericedit',
    edit: { params: { min: 1, max: 10000 } },
  },
  {
    field: 'Work',
    headerText: 'Work',
    width: 60,
    edit: { params: { min: 0, max: 10000 } },
  },
  {
    field: 'Duration',
    headerText: 'Dur',
    visible: false,
    width: 60,
  },
  {
    width: '110',
    field: 'StartDate',
    // format:'dd/MM/yyyy HH:mm',
  },
  {
    width: '110',
    field: 'EndDate',
    // format:'dd/MM/yyyy HH:mm',
  },
  {
    field: 'status_code',
    headerText: 'Status Code',
    width: 40,
    visible: true,
    allowEditing: true,
    edit: getParamsDD(
      { value: 'value', text: 'alias' },
      'status_code',
      'global-filter?where=operation$status$isEnabled€1'
    ),
  },
  {
    width: 60,
    field: 'shift',
    headerText: 'Shift',
    allowEditing: false,
    edit: getParamsDD(
      { text: 'rosterCode', value: 'rosterId' },
      'shift',
      'shift'
    ),
  },
  {
    field: 'priority_code',
    headerText: 'Priority',
    width: 40,
    visible: false,
    allowEditing: false,
  },
  process.env.REACT_APP_ERP_TYPE == 'MEX'
    ? {
      width: 70,
      field: 'order_resp_code',
      headerText: 'Resp',
      allowEditing: true,
      visible: false,
      edit: getParamsDD(
        { value: 'sys_tbl_code', text: 'sys_description' },
        'order_resp_code',
        'system-config?where=P2'
      ),
    }
    : {
      width: 70,
      field: 'order_resp_code',
      headerText: 'Resp',
      allowEditing: true,
      visible: true,
      edit: getParamsDD(
        { value: 'sys_tbl_code', text: 'sys_description' },
        'order_resp_code',
        'system-config?where=P2'
      ),
    },

  {
    width: 60,
    field: 'Progress',
    visible: false,
  },
  {
    width: 80,
    field: 'planned_by',
    headerText: 'Planned By',
    visible: false,
  },
  {
    visible: false,
    field: 'description',
    headerText: 'WO Description',
  },
  {
    width: '150',
    field: 'site_details_1',
    headerText: 'Asset Type',
    visible: false,
  },
  {
    width: '250',
    field: 'operationDescription',
    headerText: 'Op. Description',
    visible: false,
  },
  {
    width: '150',
    field: 'description',
    headerText: 'WO Description',
    visible: false,
  },
  {
    width: '150',
    field: 'Predecessor',
    visible: false,
  },
  {
    field: 'isEffected',
    textAlign: 'Left',
    width: 45,
    visible: false,
    clipMode: 'EllipsisWithTooltip',
    type: 'boolean',
  },
];
const timelineSettings: any = {
  weekStartDay: 1,
  timelineUnitSize: 50,
  topTier: {
    format: 'MMM dd, yyyy',
    unit: 'Week',
  },
  bottomTier: {
    unit: 'Day',
  },
};
const editDialogFields: any = [{ type: 'General' }];
let gantObj: GanttComponent = new GanttComponent([]);
let isMountedCS = false;
var batch_obj: Array<any> = [];
var toolbar = [
  'Edit',
  'Update',
  'Cancel',
  'ExpandAll',
  'CollapseAll',
  'Search',
  'CsvExport',
  'PdfExport',
  'ExcelExport',
  {
    text: 'Schedule',
    tooltipText: 'Scheduler',
    prefixIcon: 'e-timeline-month',
    id: 'scheduler',
  },
  {
    text: 'Refresh',
    tooltipText: 'Refresh',
    prefixIcon: 'e-repeat',
    id: 'refresh',
  },
  // {
  //   text: 'Mass Edit',
  //   tooltipText: 'Mass Edit',
  //   prefixIcon: 'e-edit',
  //   id: 'massedit',
  // },
];
let current_query = '';
let theQueryPlanId = '';
let theQuerySearch = '';
let allowToFire = true;
let dateTimePicker: DateTimePickerComponent;
function PlanningConsole() {
  let timezone_offset = useSelector(
    (state: any) => state.search.timezone_offset
  );
  let offsetMillis = (timezone_offset * 60 * 1000);
  const ERP_TYPE = process.env.REACT_APP_ERP_TYPE;
  const context = useContext(ThemeContext);
  const [dayWorkingTime, setDayWorkingTime] = useState<Array<any>>([{ from: 0, to: 24 }]);
  const theGanttSearchFromRedux = useSelector(
    (state: any) => state.search.searchCaseGantt
  );
  const [hideAddDialog, setHideAddDialog] = useState(false);
  const getPlanOrderGant = async (cond: string) => {
    let orderResponse = await getFilteredOrder(current_query, applyTheRule, 'planning-console-section');
    current_query = await applyTheRule('uw_order', 'Cloud Scheduler');
    let id = cond.toString();
    let theData = await GetGanttDataByPlan(id);
    if (theData.length === 1) {
      if (theData[0].order_id === null && theData[0].order_code === null) {
        Message.info('No data to show.');
        return;
      }
    }

    const orderCodes = new Set(orderResponse?.data?.map((order: any) => order.order_code));

    let orders = Array.from(orderCodes);
    orders = orders.map((item: any) => item.trim());
    let lastOrders = new Set(orders);

    theData = theData?.filter((item: any) => lastOrders.has(item.order_code?.trim()));
    const model = [];
    for (let i = 0; i < theData.length; i++) {
      const res = theData[i];
      if (res.order_id === null || res.order_code === null) {
        continue;
      }
      model.push({
        ...res,
        EndDate: res.planned_end_date,
        StartDate: res.planned_start_date,
        TaskID: res.order_id,
        TaskName: res.order_code + ' - ' + res.description,
        isChecked: false,
        isEffected:res.isEffected,
        subtasks: res.subtasks.map((sub: any) => {
          return {
            ...sub,
            isRejected: res.isRejected,
            Duration: +sub?.duration,
            Progress: sub?.percentage,
            Segments: sub?.Segments ? sub?.Segments : [],
            isDone: res?.isDone,
            StartDate:
              sub?.scheduled_start_date !== null
                ? sub?.scheduled_start_date
                : sub?.plannedStartDate !== null
                  ? sub?.plannedStartDate
                  : '',
            EndDate:
              sub?.scheduled_end_date !== null
                ? sub?.scheduled_end_date
                : sub?.plannedEndDate !== null
                  ? sub?.plannedEndDate
                  : '',
            TaskID: sub?.operationId,
            Work: Number(sub?.estHours),
            TaskName:
              sub?.operationSequence + ' - ' + sub?.operationDescription, 
            info: sub?.longDescription,
            Predecessor: sub?.dependencyCode,
            long_description: `<${sub?.tradeCode}> ${res.description}`,
            operationDescription: res.description,
            asset_code: sub?.assetCode,
            type_code: sub?.typeCode,
            priority_code: sub?.priority,
            isChecked: false,
            isEffected:sub.isEffected,
          };
        }),
      });
    }
    loadingShow(false);
    if (isMountedCS) {
      gantObj.dataSource = model;
      gantObj.refresh();
    }
  };
  const buildQuery = async () => {
    loadingShow(true);
    current_query = current_query.trimEnd();
    current_query = current_query.replace(theQueryPlanId, '');
    current_query = current_query.replace(theQuerySearch, '');
    theQueryPlanId = '';
    if (context.planId !== 0) {
      if (current_query !== '') {
        theQueryPlanId = addToQuery(
          'plan_id',
          '=',
          'andWhere',
          context.planId?.toString()
        );
      } else {
        theQueryPlanId = addToQuery(
          'plan_id',
          '=',
          'where',
          context.planId?.toString()
        );
      }
      current_query += theQueryPlanId;
    }
    if (theGanttSearchFromRedux !== '') {
      theQuerySearch = '$' + theGanttSearchFromRedux;
      current_query = current_query + theQuerySearch;
    }
    await getPlanOrderGant(current_query);
    loadingShow(false);
  };
  const reSchedulerGantt = (date?: Date) => {
    // allowToFire = false;
    let theAllChildsFromParent: Array<any> = [];
    var theData = gantObj.selectionModule.getSelectedRecords() as any;
    theData?.map((theEl: any) => {
      if (!theEl.hasChildRecords) {
        theAllChildsFromParent.push(theEl);
      } else {
        theEl.childRecords.map((child: any) => {
          //child.isChecked=true;
          theAllChildsFromParent.push(child);
        });
      }
    });
    theAllChildsFromParent?.map((theChild, index) => {
      if (index === theAllChildsFromParent.length - 1) {
        allowToFire = true;
      }
      var theSelectedData = gantObj.flatData[theChild.index] as any;

      theSelectedData.StartDate = date;

      const data = theSelectedData;
      //gantObj.refresh()
      gantObj.updateRecordByID(data);
    });
    // setState({ hideSchedulerTimeDialog: false, hidePercentage: false });
  };
  useEffect(() => {
    loadingShow(true)
    isMountedCS = true;
    const get = async () => {
      current_query = await applyTheRule('uw_order', 'Cloud Scheduler');
      if (current_query === '') {
        buildQuery()
      }
      await getGanttSettings();
   
    };
    get();
    if (context.planId !== 0 || theGanttSearchFromRedux !== '') buildQuery();
    loadingShow(false)
    return () => {
      isMountedCS = false;
    };
  }, []);
  useEffect(() => {
    if (context.planId !== 0 || theGanttSearchFromRedux !== '') buildQuery();
  }, [context.planId, theGanttSearchFromRedux]);
  const getGanttSettings = async () => {
    await GetGanttSettings('gantt$workingTime').then((res) => {
      if (isMountedCS) {
        if (res.data[0]) {
          let value = JSON.parse(res.data[0]?.content);
          if (Array.isArray(value)) {
            setDayWorkingTime(value);
          }
        }
      }
    });
  };
  const actionCompletedElement = (args: any) => {
    if (args.requestType === 'save') {
      if (allowToFire) {
        batch_obj = [];
      }
      arrayPreparing(
        args.modifiedRecords,
        batch_obj,
        false,
        dayWorkingTime,
        []
      );
      if (allowToFire) {
        if (ERP_TYPE === 'MEX') {
          batch_obj.map((item: any) => {
            item.scheduled_start_date = new Date(new Date(item.scheduled_start_date)?.getTime() + offsetMillis);
            item.scheduled_end_date = new Date(new Date(item.scheduled_end_date)?.getTime() + offsetMillis);
          })
        }
        SavePointOfTheGantt(batch_obj, () => {
          buildQuery();
          setHideAddDialog(false);
        });
      }
    }
  };
  const onToolbarClick = (args: any) => {
    if (args.item.id === 'refresh') {
      buildQuery();
    }
    if (args.item.id === 'scheduler') {
      if (gantObj.selectionModule.getSelectedRecords().length !== 0) {
        setHideAddDialog(true);
      } else {
        Message.error('No records selected to Assign');
      }
    }
  };
  const queryCellInfo = (args: any) => {
    if (
      args.column.field === 'estHours' ||
      args.column.field === 'duration' ||
      args.column.field === 'required'
    ) {
      args.cell.innerHTML = Number(args.cell.innerHTML).toFixed(2);
    }
    if (
      args.column &&
      args.column.type === 'checkbox' &&
      args.data &&
      args.cell
    ) {
      let isEffected = args.data.isEffected;
      let theCurrenColor = 'transparent';
      if (isEffected) {
        theCurrenColor = '#8ECDDD';
      }
      args.cell.setAttribute('style', `background-color:${theCurrenColor}!important;`);
    }
    if (args.data.level === 0) {
      args.cell.classList.add('gantt-row-level-0');
      if (
        args.column.field === 'required' &&
        args.data.childRecords.length > 0
      ) {
        args.cell.innerHTML = Number(
          args.data.childRecords.reduce(
            (a: any, b: any) => Number(a) + Number(b.required),
            0
          )
        ).toFixed(2);
      }
    }
  };
  const schedulerGanttRecords = () => {
    if (dateTimePicker.value === null) {
      Message.error('Scheduler date is mandatory');
      return;
    }
    reSchedulerGantt(dateTimePicker.value);
  };

  return (
    <div>
      <GanttComponent
        id='planning-console-gantt'
        ref={(gant: GanttComponent) => (gantObj = gant)}
        dateFormat='dd/MM/yyyy HH:mm'
        durationUnit='Hour'
        toolbarClick={onToolbarClick}
        toolbar={toolbar}
        treeColumnIndex={3}
        queryCellInfo={queryCellInfo}
        showColumnMenu={true}
        actionComplete={actionCompletedElement}
        width={'100%'}
        height={'calc(-130px + 100vh)'}
        workUnit='Hour'
        connectorLineBackground='red'
        dayWorkingTime={dayWorkingTime}
        taskType='FixedWork'
        workWeek={[
          'Monday',
          'Tuesday',
          'Wednesday',
          'Thursday',
          'Friday',
          'Saturday',
          'Sunday',
        ]}
        editDialogFields={editDialogFields}
        taskFields={{
          id: 'TaskID',
          name: 'TaskName',
          startDate: 'StartDate',
          endDate: 'EndDate',
          duration: 'Duration',
          progress: 'Progress',
          work: 'Work',
          child: 'subtasks',
        }}
        gridLines={'Both'}
        timelineSettings={timelineSettings}
        labelSettings={labelSettings}
        editSettings={editSettings}
        splitterSettings={{ view: 'Grid', minimum: '100%' }}
        filterSettings={{ type: 'Menu' }}
        enableContextMenu={true}
        enableVirtualization={false}
        allowFiltering={true}
        allowSorting={true}
        allowResizing={true}
        allowRowDragAndDrop={false}
        allowExcelExport={true}
        allowPdfExport={true}
        allowReordering={true}
        highlightWeekends={true}
      >
        <ColumnsDirective>
          {columns.map((el: any) => {
            return (
              <ColumnDirective
                key={el.field}
                field={el.field}
                headerText={el.headerText}
                width={el.width}
                visible={el.visible}
                editType={el.editType}
                edit={el.edit}
                type={el.type}
                format={el.format}
                allowEditing={el.allowEditing}
                displayAsCheckBox={el.displayAsCheckBox}
                template={el.template}
              />
            );
          })}
        </ColumnsDirective>
        <EditDialogFieldsDirective>
          <EditDialogFieldDirective
            type='General'
            headerText='General'
          ></EditDialogFieldDirective>
        </EditDialogFieldsDirective>
        <Inject
          services={[
            Edit,
            Selection,
            Toolbar,
            DayMarkers,
            CriticalPath,
            Resize,
            Filter,
            ContextMenu,
            ColumnMenu,
            VirtualScroll,
            ExcelExport,
            PdfExport,
            Sort,
            Reorder,
          ]}
        />
      </GanttComponent>
      {hideAddDialog ? (
        <GlobalDialog
          showDialog={hideAddDialog}
          setShowDialog={(val) => setHideAddDialog(val)}
          header='Set schedule date'
          width={'350px'}
          hideDoneButton={true}
          buttons={[
            {
              click: () => schedulerGanttRecords(),
              buttonModel: {
                content: 'Yes',
                isPrimary: true,
              },
            },
            {
              click: () => setHideAddDialog(false),
              buttonModel: {
                content: 'No',
              },
            },
          ]}
        >
          <DateTimePickerComponent
            placeholder='Select a date'
            ref={(scope: DateTimePickerComponent) => (dateTimePicker = scope)}
            format={'dd/MM/yyyy HH:mm'}
          />
        </GlobalDialog>
      ) : null}
    </div>
  );
}

export default PlanningConsole;
